"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlayButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function Play(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M18.2 10.726l-9.5-6.57c-.28-.16-.55-.19-.81-.12s-.39.42-.39 1v12.94c0 .54.14.86.41.97.28.11.54.08.79-.1l9.5-6.57c.2-.21.3-.48.3-.77.01-.29-.1-.57-.3-.78z",
    fill: "#111"
  }));
}
function Pause(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19H8V5h2v14zm6-14h-2v14h2V5z",
    fill: "#111"
  }));
}
const PlayButtonWrapper = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "PlayButtonWrapper",
  class: "pl-pxoycv",
  vars: {
    "pxoycv-0": [({
      invert
    }) => invert ? _intents.default.ux.boxHighContrast.backgroundColor : _intents.default.ux.box.backgroundColor],
    "pxoycv-2": [({
      invert
    }) => invert ? _intents.default.ux.box.backgroundColor : _intents.default.ux.boxHighContrast.backgroundColor]
  }
});

/**
 * SlideItem component.
 *
 * @param {Object} props React props
 * @param {String} props.id id for the button
 * @param {function} props.handlePlay handlePlay
 * @param {String} props.ariaLabel button aria label
 * @param {String} props.size size
 * @param {Boolean} props.invert invert color scheme
 * @param {Boolean} props.pause pause
 * @param {String} props.dataCy dataCy
 * @returns {React.ReactElement} SlideItem component
 * @public
 */

function PlayButton({
  id,
  handlePlay,
  ariaLabel = 'Play button',
  size = 'medium',
  invert = false,
  partial,
  pause,
  dataCy = 'play-button'
}) {
  return /*#__PURE__*/_react.default.createElement(PlayButtonWrapper, (0, _extends2.default)({}, id && {
    id: `${id}-play-button`
  }, {
    "data-cy": dataCy,
    className: size,
    "aria-label": ariaLabel,
    size: size,
    onClick: handlePlay
  }, _patternLibraryUtils.tracking.create(pause ? 'pause' : 'play', true, true), {
    "data-partial": partial || (invert ? 'dark1' : '')
  }), pause ? /*#__PURE__*/_react.default.createElement(Pause, null) : /*#__PURE__*/_react.default.createElement(Play, null));
}
PlayButton.propTypes = {
  id: _propTypes.default.string,
  handlePlay: _propTypes.default.func,
  ariaLabel: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  pause: _propTypes.default.bool,
  _name: _propTypes.default.string,
  dataCy: _propTypes.default.string
};